import { reactive } from "vue";
import { defineStore } from "pinia";
import { translate } from "@/services/translation.service";

export const useTranslationStore: any = defineStore("translation",
  () => {
    // state properties
    const translationObject: any = reactive({
      texts: {},
    });

    // actions
    /**
     * Method for getting translations
     */
    const getTranslations = async () => {
      const idArray = [
        707, 708, 708, 731, 732, 733, 734, 736, 737, 739, 740,
        1192, 1193, 1201, 1365, 1366, 1367, 1374, 1383, 1386, 1401, 1408,
        1409, 1415, 1445, 1474, 1475, 2381, 3614, 3645, 3678, 3680, 3685, 5662,
        6306, 6442, 7738, 7815, 7854, 7855, 7858, 7912, 7928, 8053, 8059,
        8060, 8311, 8331, 8332, 8374, 8491, 9373, 6227,
        10187, 10188, 12220, 12290, 12336, 12483, 12488, 12638, 12700, 12856,
        13003, 13082, 13295, 13456, 13504, 13596, 13597, 13598, 13599, 13600,
        13601, 13602, 13603, 13604, 13605, 13606, 13607, 13608, 13609, 13611,
        13612, 13613, 13614, 13615, 13616, 13617, 13618, 13619, 13620, 13621,
        13622, 13623, 13624, 13625, 13626, 13627, 13628, 13629, 13630, 13631,
        13632, 13633, 13634, 13635, 13636, 13637, 13638, 13639, 13640, 13641,
        13642, 13643, 13644, 13645, 13646, 13647, 13648, 13649, 13650, 13651,
        13652, 13653, 13654, 13655, 13656, 13657, 13658, 13659, 13660, 13661,
        13662, 13663, 13664, 13665, 13666, 13667, 13668, 13669, 13670, 13671,
        13672, 13673, 13674, 13675, 13676, 13677, 13678, 13679, 13680, 13681,
        13682, 13738, 13739, 13768, 13769, 13770, 13771, 13772, 13773, 13774,
        13775, 13776, 13778, 13787, 13850, 13851, 13852, 13856, 13857, 13858,
        13860, 13861, 13862, 13863, 13864, 13866, 13867, 13875, 13877, 13878,
        13881, 13882, 13883, 13884, 13885, 13886, 13887, 13888, 13889, 13890,
        13899, 13900, 13901, 13902, 13904, 13905, 13906, 13907, 13910, 13911,
        13912, 13913, 13914, 13920, 13923, 13924, 13925, 13926, 13927, 13928,
        13929, 13930, 13931, 13932, 13933, 13934, 13935, 13936, 13937, 13938,
        13940, 13941, 13942, 13943, 13944, 13956, 13964, 13986, 13987, 13988,
        13993, 12508, 12509, 12510, 14021, 13918, 14022, 14023, 12777, 14024,
        14025, 12745, 12725, 12735, 12698, 2459, 2510, 14068, 14081, 14082,
        14079, 14100, 14111, 14112, 14074, 14119, 14129, 13876, 14152, 14153,
        14154, 7245, 14155, 14156, 13229, 14157, 12290, 14158, 14159, 14136,
        14137, 7837, 14138, 14139, 14140, 14141, 14142, 14143, 14162, 14163,
        14164, 12768, 14165, 14166, 14167, 14168, 14169, 14172, 14173, 13162,
        14182, 12741, 12474, 12475, 12476, 12477, 12746, 14200, 14224, 14225,
        14226, 14227, 13499, 14237, 12709, 12708, 14238, 14239, 14240, 12328,
        14241, 14211, 14244, 14245, 14246, 14247, 14248, 14249
      ];

      // translationObject.texts has any of the ids above, remove them from the idArray
      const idsToRemove = Object.keys(translationObject.texts).map(Number);
      const filteredIds = idArray.filter((id) => !idsToRemove.includes(id));

      if (!filteredIds.length) {
        return;
      }

      const chunkSize = 110
      const idChunks = idChunkArray(filteredIds, chunkSize)

      const results = {}

      for (const chunk of idChunks) {
        const resultChunk = await translate({
          id: chunk,
          language: "da",
        })

        Object.assign(results, resultChunk)
      }

      translationObject.texts = {
        ...translationObject.texts,
        ...results
      };
    };

    const getTranslationsByIds = async (ids) => {
      const chunkSize = 110
      const idChunks = idChunkArray(ids, chunkSize)

      const results = {}

      for (const chunk of idChunks) {
        const resultChunk = await translate({
          id: chunk,
          language: "da",
        })

        Object.assign(results, resultChunk)
      }

      translationObject.texts = results
    };

    const getTranslation = (id: number) => {
      return translationObject.texts[id] || "";
    }

    const idChunkArray = (array, chunkSize) => {
      const results = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        results.push(array.slice(i, i + chunkSize));
      }
      return results;
    };

    return {
      translationObject,
      getTranslations,
      getTranslation,
      getTranslationsByIds
    };
  },
  {persist: false});
